import { CAST_AI } from '@cast/constants';
import { K8sProvider } from '@cast/shared-types';
import { PROVIDER_NAME_MAP } from '@cast/utils';

const getProviderName = (provider: `${K8sProvider}`): string =>
  PROVIDER_NAME_MAP[provider] || provider.toUpperCase();

const getKarpenterMessage = (provider?: `${K8sProvider}`): string =>
  provider
    ? `Karpenter on ${getProviderName(provider)}, managed by ${CAST_AI}`
    : `Karpenter managed by ${CAST_AI}`;

const getCastManagedMessage = (provider?: `${K8sProvider}`): string => {
  if (!provider) {
    return `${CAST_AI} managed`;
  }

  // 'k8s on EC2' is already a full noun phrase, no " cluster" suffix
  if (provider === 'self_hosted_with_ec2_nodes') {
    return `${CAST_AI} managed k8s on EC2`;
  }

  return `${CAST_AI} managed ${getProviderName(provider)} cluster`;
};

const getUnmanagedMessage = (provider?: `${K8sProvider}`): string => {
  if (!provider) {
    return '';
  }

  if (provider === 'self_hosted_with_ec2_nodes') {
    return 'k8s on EC2';
  }

  return `${getProviderName(provider)} cluster`;
};

export const getProviderTooltipMessage = ({
  provider,
  castEnabled,
  isKentManagedCluster,
}: {
  provider?: `${K8sProvider}`;
  castEnabled: boolean;
  isKentManagedCluster: boolean;
}): string => {
  if (castEnabled) {
    return getCastManagedMessage(provider);
  }

  if (isKentManagedCluster) {
    return getKarpenterMessage(provider);
  }

  return getUnmanagedMessage(provider);
};
